export class AutoCall {
  constructor(eventId, store, autoplay) {
    this.eventId = eventId
    this.store = store
    this.autoplay = autoplay
  }

  hang() {
    this.store.state.autoCall = null
  }
}
